<template>
  <b-modal
    id="modal-upload-document"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    scrollable
    body-class="common_modal modal_visible"
    hide-header
    hide-footer
    centered
    size="lg"
    hide-header-close
  >
    <template #modal-header="{ close }">
      <h3 class="m-0">
        {{ newDocumentData.id > 0 ? "上傳" : "修改" }}文件資料
      </h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <upload-file-single
              v-on:file-uploaded="onFileUploaded"
            ></upload-file-single>
          </b-col>
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            上傳
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>
  
  <script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import { required } from "@validations";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import uploadFileSingle from "@/layouts/components/file/uploadFileSingle.vue";
import axiosIns from "@/libs/axios.js";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormInvalidFeedback,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    uploadFileSingle,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    documentData: {
      type: Object,
      required: true,
    },
    project_progress_id:{}
  },
  data() {
    return {
      required,
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-upload-document");
    },
    onFileUploaded(file) {
      this.newDocumentData.file = file;
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();
          formData.append('project_progress_id', this.newDocumentData.project_progress_id  ? this.newDocumentData.project_progress_id : this.project_progress_id);

            if (this.newDocumentData.file) {
              if (this.newDocumentData.file.size >= 2097152) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Error! Your Image size is larger then 2M",
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                });
                return false;
              } else {
                formData.append("file", this.newDocumentData.file);
              }
            }

          this.loading = true;
          axiosIns
            .post('/projects/progress/documents', formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.$bvModal.hide("modal-upload-document");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    deleteDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosIns
            .post(this.deleteApiUrl, { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const loading = ref(false);
    const newDocumentData = ref({ id: 0 });
    watch(
      () => props.documentData,
      (newVal) => {
        newDocumentData.value = { ...newVal };
      }
    );

    const resetDocumentData = () => {
      props.documentData = JSON.parse(JSON.stringify({ id: 0 }));
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetDocumentData);

    return {
      loading,
      newDocumentData,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>
  
  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
  